const STATUS_CODES = {
  UNAUTHORIZED: 401,
  UNPROCESSABLE_ENTITY: 422
};

const NETWORK_ERROR = 'Network Error';

export { STATUS_CODES, NETWORK_ERROR };
